import PaymentTypeSelector from 'views/_Order/OrderPay/PaymentTypeSelector';
import InvoiceInfo from './InvoiceInfo';
import {useDictionary} from '@adamlip/okeoke.client';
import {useState, useContext} from 'react';
import useBasket from 'hooks/useBasket';
import SelectTableModal from 'components/Modals/SelectTableModal';
import {AppParamsContext} from 'contexts/AppParamsContext';
import LocationCard from 'views/_Order/BasketModal/LocationCard';
import SubmitOrderBtn from 'views/_Order/BasketModal/Slides/Payment/SubmitOrderBtn';

export default function Payment({setOrderSubmitLoading, usableMoney, setIsOpen, paymentModalOpen, setPaymentModalOpen, payByVipMoney, setPayByVipMoney}) {
	const {appParams} = useContext(AppParamsContext);
	const {getValue} = useDictionary();

	const {setSelectedPayment, handleChangePaymentType, orderIdentifier, notes, tableInfo} = useBasket();

	const [addCouponModalOpen, setAddCouponModalOpen] = useState(false);
	const [activatePointsModalOpen, setActivatePointsModalOpen] = useState(false);
	const [selectTableOpen, setSelectTableOpen] = useState(false);

	const handleSelectPayment = (payment) => {
		if (payment != null) {
			setSelectedPayment(payment);
			handleChangePaymentType('Online');
		}
	};

	return (
		<>
			<SelectTableModal isOpen={selectTableOpen} setIsOpen={setSelectTableOpen} />
			<div className=' flex flex-col gap-2 grow overflow-y-scroll overflow-x-hidden px-2 '>
				<div className='flex w-full flex-col gap-0'>
					<div className='text-xs opacity-70'>{getValue('app_v2_basket_orderIdentifier')}:</div>
					<div className='text-lg font-bold'>{orderIdentifier}</div>
				</div>
				{notes?.length > 0 && (
					<div className='flex w-full flex-col gap-0'>
						<div className='text-xs opacity-70'>{getValue('app_v2_basket_orderNotes')}:</div>
						<div className='italic w-full text-left text-sm'>{notes}</div>
					</div>
				)}
				{tableInfo?.name?.length > 0 && (
					<div className='flex flex-row gap-2 items-center justify-between'>
						<div className='flex'>
							<div className='mr-2'>{getValue('app_v2_basket_selectedTable')}:</div>
							<div className='font-bold'>{tableInfo?.name}</div>
						</div>
					</div>
				)}
				<InvoiceInfo />
				{appParams?.basketModal?.visibleBlocks?.locationsOnPayment && <LocationCard />}
				<PaymentTypeSelector onSelectPayment={handleSelectPayment} usableMoney={usableMoney} setPayByVipMoney={setPayByVipMoney} payByVipMoney={payByVipMoney} paymentModalOpen={paymentModalOpen} setPaymentModalOpen={setPaymentModalOpen} />
			</div>
			<SubmitOrderBtn setIsOpen={setIsOpen} usableMoney={usableMoney} payByVipMoney={payByVipMoney} setOrderSubmitLoading={setOrderSubmitLoading} setPaymentModalOpen={setPaymentModalOpen} />
		</>
	);
}
